import { v4 as uuidv4 } from 'uuid';
import { CultureTextModel } from './form';
import { formatMessageByCulture } from '../../utilities/CultureUtilities';

export class PaymentOption {
  public price: number;
  public description: CultureTextModel[] | string;
  public text: CultureTextModel[] | string;
  public value: string;
  public limit?: number;

  constructor(cultures: string[]) {
    this.value = uuidv4();
    this.price = 0;

    this.text = [];
    this.description = [];

    for (const culture of cultures) {
      this.text.push({ culture, value: formatMessageByCulture('toolbox.labels.option', culture) });
    }
  }
}
